import React, { useCallback, useContext, useEffect, useMemo } from 'react'
import { useAppSelector, useAppDispatch } from './reduxHooks'
import useWhiteLabelAppConfig from './useWhiteLabelAppConfig'
import { fetchWhiteLabelAppPromoByMemberId, ignoreWhiteLabelAppPromoForMemberId } from 'actions/WhiteLabelAppActions'
import ModalContext from 'contexts/ModalContext'
import config from 'constants/config'
import { TREATME_TRAVEL } from 'constants/brands'
import WhiteLabelAppPromoModal from 'components/WhiteLabelApp/WhiteLabelAppPromoModal'

function useWhiteLabelAppPromo() {
  const dispatch = useAppDispatch()
  const currentRegion = useAppSelector((state) => state.geo.currentRegionCode)
  const memberId = useAppSelector((state) => state.auth.account.memberId)
  const promoCode = useAppSelector(state => state.whiteLabelApp.promoCode)

  const showModal = useContext(ModalContext)
  const whiteLabelAppConfig = useWhiteLabelAppConfig()

  const shouldEnableCampaign = useMemo(() =>
    currentRegion === 'AU' &&
    config?.WHITE_LABEL_APP_GRILLD_PROMO_CAMPAIGN_ENABLED &&
    config.BRAND !== TREATME_TRAVEL &&
    whiteLabelAppConfig.isApp,
  [whiteLabelAppConfig.isApp, currentRegion])

  useEffect(() => {
    if (shouldEnableCampaign && memberId) {
      // TODO: in feature we will need the external provider name from the API
      dispatch(fetchWhiteLabelAppPromoByMemberId({ memberId, externalProviderName: 'grilld' }))
    }
  }, [dispatch, memberId, shouldEnableCampaign])

  const openWhiteLabelAppPromo = useCallback(() => {
    // TODO: in feature we will need the external provider name from the API and map to build the url
    const url = `https://grilld.com.au/applink/profile/referrals/${promoCode}/`
    window.location.href = url
  }, [promoCode])

  const onClose = useCallback(() => {
    if (memberId && promoCode) {
      dispatch(ignoreWhiteLabelAppPromoForMemberId({ memberId, promoCode }))
    }
  }, [dispatch, memberId, promoCode])

  useEffect(() => {
    if (shouldEnableCampaign && memberId && promoCode) {
      showModal(<WhiteLabelAppPromoModal
        // TODO: in feature we will need the external provider name from the API to build these props
        title={'You’ve unlocked a $10 Grill\'d coupon!'}
        description={'Enjoy an exclusive $10 Grill\'d coupon — on us! Simply tap the link below, log in to your Grill\'d Relish account, and it\'s all yours.'}
        primaryActionText="Claim your $10 coupon"
        onClickAction={openWhiteLabelAppPromo}
        onClose={onClose}
      />)
    }
  }, [memberId, promoCode, shouldEnableCampaign, onClose, showModal, openWhiteLabelAppPromo])
}

export default useWhiteLabelAppPromo
